/** HiroMatch logomark — two intersecting circles (brand C2). */
export function HiroMark({ className = 'h-10 w-10' }: { className?: string }) {
  return (
    <svg viewBox="0 0 360 320" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <clipPath id="hm-brand-clip">
          <circle cx="225" cy="160" r="90" />
        </clipPath>
      </defs>
      <circle cx="135" cy="160" r="88" fill="#C4B5FD" opacity="0.95" />
      <circle cx="225" cy="160" r="90" fill="#A78BFA" opacity="0.9" />
      <circle cx="135" cy="160" r="88" fill="#7C3AED" opacity="0.5" clipPath="url(#hm-brand-clip)" />
    </svg>
  );
}
